import { render, staticRenderFns } from "./goods-detail.vue?vue&type=template&id=9e83c6aa"
import script from "./goods-detail.vue?vue&type=script&lang=js"
export * from "./goods-detail.vue?vue&type=script&lang=js"
import style0 from "./goods-detail.vue?vue&type=style&index=0&id=9e83c6aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports